import React, { useState } from 'react'
import {
  useDispatch,
  useStore,
  useSelector,
  ReactReduxContext
} from 'react-redux'

import {
  Space,
  Card,
  Table,
  Button,
  Input,
  Divider,
  Select,
  Collapse,
  Row,
  Col,
  AutoComplete,
  Modal,
  Form,
  message,
  Pagination,
  Switch,
  Tabs,
  Tag,
  Spin,
  DatePicker,
  Radio
} from 'antd'
import IntlMessages from '../util/IntlMessages'
import ds from '../Services/DataServices'
import Skeleton from 'react-loading-skeleton'
import { useHistory } from 'react-router-dom'
import { setCommonConfigs } from '../appRedux/actions/CommonData'
import Icon, { ArrowLeftOutlined, InfoCircleFilled } from '@ant-design/icons'
import {
  StringIsNullOrEmpty,
  isEmptyObject,
  checkRightspermissions,
  getDecryptID,
  notAllowMsgCheck,
  removeSpacewithLowerCaseString
} from '../appRedux/actions'
import { INVENTORY_SCREEN } from '../constants/Pages'
import { BEHAVIOUR_TYPE } from '../Services/DataServices'
import moment from 'moment'
import { checkIsWeb } from '../appRedux/actions/MobAppFn'

const Panel = Collapse.Panel
const TabPane = Tabs.TabPane
const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
    md: { span: 24 }
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
    md: { span: 24 }
  }
}

const viewByOptions = [
  { label: 'Day', value: 'Day' },
  { label: 'Week', value: 'Week' },
  { label: 'Month', value: 'Month ' }
]

const StockOrderTypesEnum = {
  OrderStock: '1',
  ReceiveStock: '2',
  TransferStock: '3',
  ReturnStock: '4'
}
const EntitiesEnum = {
  Products: '5',
  StockOrders: '10',
  InventoryTakes: '11',
  SalesOrder: '12'
}
const SalesOrderStatusesEnum = {
  LAYBY: '1',
  ONACCOUNT: '2',
  SAVED: '3',
  AWAITING_DISPATCH: '4',
  AWAITING_PICKUP: '5',
  CLOSED: '6',
  LAYBY_CLOSED: '7',
  ONACCOUNT_CLOSED: '8',
  DISPATCHED_CLOSED: '9',
  PICKED_UP_CLOSED: '10',
  VOIDED: '11',
  InProgress: '12',
  RETURN_COMPLETED: '13',
  PARKED_RETURN: '14',
  EXCHANGE_COMPLETED: '16'
}
const { RangePicker } = DatePicker

const InventoryMovementListing = props => {
  const productID = props.productID
  const isComponent = props.isComponent ? props.isComponent : false

  const [form] = Form.useForm()
  const history = useHistory()
  const dispatch = useDispatch()
  const [visible, setVisible] = React.useState(false)
  const [isLoading, setIsLoading] = React.useState(true)
  const [outletData, setOutletData] = useState([])
  const [getCurrData, setCurrData] = useState({})
  const [getShortCurr, setShortCurr] = useState('')
  const [getCurrSymbol, setCurrSymbol] = useState('')
  const [getIsDisableCreate, setIsDisableCreate] = useState(true)
  const [getIsDisableUpdate, setIsDisableUpdate] = useState(true)
  const [getIsDisableDelete, setIsDisableDelete] = useState(true)
  const [getIsAllowRead, setIsAllowRead] = useState(false)
  const [getAccessLoading, setAccessLoading] = useState(true)
  const [getRights, setRights] = useState([])
  const [getPermissions, setPermissions] = useState([])
  const [getMovementStatuses, setMovementStatuses] = React.useState([])
  const [getProductMovementsData, setProductMovementsData] = React.useState([])
  const [getPagination, setPagination] = React.useState({
    CurrentPageNo: 1,
    PageSize: props.pageSize
  })
  const [searchFilterData, setSearchFilterData] = React.useState({})
  const [getFromDate, setFromDate] = React.useState()
  const [getToDate, setToDate] = React.useState()
  const [getListingLoader, setListingLoader] = React.useState(true)
  const [getProductName, setProductName] = React.useState('')
  const [getProductInventoryTypeID, setProductInventoryTypeID] =
    React.useState(4) //StandardProduct By Defaul
  //#region  for use Selector

  const getReduxCommonSetting = useSelector(
    ({ commonConfigs }) => commonConfigs.pageCommonConfigs
  )

  //#endregion use Selector Region

  //#region  for use Effect
  React.useEffect(() => {
    let mounted = true

    if (mounted) {
      const commonData = getReduxCommonSetting

      const respData =
        commonData &&
        commonData.storeCommonConfigs &&
        commonData.storeCommonConfigs.storeConfig
          ? commonData.storeCommonConfigs.storeConfig
          : {}

      if (respData && respData.currencyData) {
        let currencyData = respData.currencyData
        setCurrSymbol(currencyData.currencySymbol)
        setShortCurr(currencyData.currencyCode)
        setCurrData(currencyData)
      }

      // rights && permissions

      if (commonData && commonData.storeCommonConfigs) {
        const rpData = checkRightspermissions(commonData)

        if (rpData && !isEmptyObject(rpData)) {
          setupRightsPermissions(rpData)

          setAccessLoading(false)
        } else {
          toInitialState()

          setAccessLoading(false)
        }
      }
    }

    return () => (mounted = false)
  }, [getReduxCommonSetting])
  function setupRightsPermissions (rpData) {
    if (rpData.rights && rpData.rights.length > 0) {
      setRights(rpData.rights)
    } else {
      setRights([])
    }

    if (rpData.permissions && rpData.permissions.length > 0) {
      setPermissions(rpData.permissions)
    } else {
      setPermissions([])
    }

    if (rpData.read) {
      setIsAllowRead(true)
    } else {
      setIsAllowRead(false)
    }

    if (rpData.create) {
      setIsDisableCreate(false)
    } else {
      setIsDisableCreate(true)
    }

    if (rpData.update) {
      setIsDisableUpdate(false)
    } else {
      setIsDisableUpdate(true)
    }

    if (rpData.delete) {
      setIsDisableDelete(false)
    } else {
      setIsDisableDelete(true)
    }
  }
  function toInitialState () {
    setRights([])

    setPermissions([])

    setIsAllowRead(false)

    setIsDisableCreate(true)

    setIsDisableUpdate(true)

    setIsDisableDelete(true)

    setAccessLoading(true)
  }

  React.useEffect(() => {
    let mounted = true
    if (mounted) {
      dispatch(setCommonConfigs(INVENTORY_SCREEN))
      getOutletsService()
      getInventoryMovementStatusesData()
      let fromDate = moment().subtract(25, 'day').format('YYYY-MM-DD')
      let toDate = moment().format('YYYY-MM-DD')
      setFromDate(fromDate)
      setToDate(toDate)
      
      let body = {
        CurrentPageNo: getPagination.CurrentPageNo,
        PageSize: getPagination.PageSize,
        ProductID: productID,
        FromDate: fromDate,
        ToDate: toDate
      }
      getProductMovementsListing(body)
    }

    return () => (mounted = false)
  }, [])
  //#endregion for use Effect

  async function getInventoryMovementStatusesData () {
    await ds
      .getInventorymovementStatusesService(BEHAVIOUR_TYPE.GET)
      .then(res => {
        // setLoader(false);
        if (res.data.data) {
          // let mapped = res.data.data.map((data, i) => {
          //   return {
          //     key: i,
          //     statusName: data.displayName,
          //     statusID: getDecryptID(data.stockOrderStatusTypeID),
          //   };
          // });

          setMovementStatuses(res.data.data)
        }
      })
      .catch(error => {
        setIsLoading(false)
      })
  }

  async function getProductMovementsListing (body) {
    await ds
      .getProductMovementsListingService(body, BEHAVIOUR_TYPE.GET)
      .then(res => {
        setListingLoader(false)
        setIsLoading(false)
        if (res.data.data != null) {
          if (res.data.data.isGet) {
            setProductName(res.data.data.productName)
            setProductInventoryTypeID(res.data.data.productInventoryTypeID)

            if (res.data.data.productMovementListings.length > 0) {
              let mapped = res.data.data.productMovementListings.map(
                (data, i) => {
                  let from = ''
                  let to = ''
                  let redirectURL = ''
                  let fromMessage = !StringIsNullOrEmpty(data.fromMessage)
                    ? data.fromMessage
                    : ''
                  let toMessage = !StringIsNullOrEmpty(data.toMessage)
                    ? data.toMessage
                    : ''
                  let recordTypeID = getDecryptID(data.recordTypeID)
                  let stockOrderTypeID = getDecryptID(data.stockOrderTypeID)
                  let fromNewCount = !StringIsNullOrEmpty(data.newCount)
                    ? data.newCount
                    : ''
                  let fromLastCount = !StringIsNullOrEmpty(data.lastCount)
                    ? data.lastCount
                    : ''

                  let toNewCount = !StringIsNullOrEmpty(data.newCount)
                    ? data.newCount
                    : ''
                  let toLastCount = !StringIsNullOrEmpty(data.lastCount)
                    ? data.lastCount
                    : ''
                  let quantity = !StringIsNullOrEmpty(data.quantity)
                    ? data.quantity
                    : !StringIsNullOrEmpty(data.newCount)
                    ? parseInt(data.newCount)
                    : 0
                  let isComposite = data.quantity != null ? true : false
                  let variantName = data.variantName
                  let isFromCountShow = true
                  let isToCountShow = true

                  if (recordTypeID == EntitiesEnum.Products) {
                    // redirectURL = `/dashboard/products/main/productdetail/${data.recordID}`;

                    if (!StringIsNullOrEmpty(data.movementName)) {
                      if (
                        removeSpacewithLowerCaseString(data.movementName) ==
                        removeSpacewithLowerCaseString(
                          'Inventory Edit (Removed)'
                        )
                      ) {
                        from = data.outletName
                        to = data.fromMessage
                        toMessage = ''
                        isToCountShow = false
                      } else if (
                        removeSpacewithLowerCaseString(data.movementName) ==
                        removeSpacewithLowerCaseString('Inventory Adjustment')
                      ) {
                        from = data.outletName // data.fromMessage
                        to = data.toMessage // data.outletName
                        var tempQuantity =
                          parseInt(data.lastCount) - parseInt(data.newCount)
                        quantity =
                          tempQuantity == 0
                            ? parseInt(data.lastCount)
                            : tempQuantity //Needs to double check and test all conditions
                        toMessage = ''
                        isToCountShow = false
                      } else {
                        from = data.fromMessage
                        to = data.outletName
                        var tempQuantity =
                          parseInt(data.newCount) - parseInt(data.lastCount)
                        quantity =
                          tempQuantity == 0
                            ? parseInt(data.lastCount)
                            : tempQuantity //Needs to double check and test all conditions
                        fromMessage = ''
                        isFromCountShow = false
                      }
                    }
                  } else if (recordTypeID == EntitiesEnum.StockOrders) {
                    redirectURL = `/Dashboard/inventory/stockcontrol/viewstock/${data.recordID}`
                    if (
                      stockOrderTypeID == StockOrderTypesEnum.OrderStock ||
                      stockOrderTypeID == StockOrderTypesEnum.ReceiveStock
                    ) {
                      if (
                        removeSpacewithLowerCaseString(data.movementName) ==
                        'orderplaced'
                      ) {
                        from = data.supplierName
                        to = data.outletName
                        isFromCountShow = false
                      } else if (
                        removeSpacewithLowerCaseString(data.movementName) ==
                        'orderreceived'
                      ) {
                        //  from = data.outletName + "0";
                        from = data.outletName
                        to = data.outletName
                        toNewCount =
                          parseInt(toNewCount) + parseInt(toLastCount)
                        isFromCountShow = false
                      } else if (
                        removeSpacewithLowerCaseString(data.movementName) ===
                        'orderreceivedmerge'
                      ) {
                        //Jugar
                        from = data.outletName
                        to = data.outletName
                        toNewCount =
                          parseInt(toNewCount) + parseInt(toLastCount)
                        fromLastCount = parseInt(quantity)
                        fromNewCount = '0'
                        isFromCountShow = true
                      } else if (
                        removeSpacewithLowerCaseString(data.movementName) ==
                        'supplierorder(cancelled)'
                      ) {
                        from = data.outletName
                        to = data.supplierName
                        fromNewCount = '0'
                        fromLastCount = parseInt(toNewCount)
                        isToCountShow = false
                      } else if (
                        removeSpacewithLowerCaseString(data.movementName) ==
                        'supplierorder(adjustment)'
                      ) {
                        from = data.outletName
                        to = data.supplierName
                        fromNewCount = '0'
                        isToCountShow = false
                      }
                    }

                    if (stockOrderTypeID == StockOrderTypesEnum.ReturnStock) {
                      from = data.outletName
                      to = data.supplierName
                      isToCountShow = false
                      fromNewCount = parseInt(toLastCount) - parseInt(quantity)
                    }

                    if (stockOrderTypeID == StockOrderTypesEnum.TransferStock) {
                      if (
                        removeSpacewithLowerCaseString(data.movementName) ==
                        'transferplaced'
                      ) {
                        from = data.outletName
                        to = data.destinationOutletName
                        fromNewCount =
                          parseInt(toLastCount) - parseInt(quantity)
                        toLastCount = '0'
                      } else if (
                        removeSpacewithLowerCaseString(data.movementName) ==
                        'transferreceived'
                      ) {
                        // from = data.outletName + "0";
                        from = data.outletName
                        to = data.outletName
                        isFromCountShow = false
                        toNewCount =
                          parseInt(toNewCount) + parseInt(toLastCount)
                      } else if (
                        removeSpacewithLowerCaseString(data.movementName) ==
                        'transferreceivedmerge'
                      ) {
                        // from = data.outletName + "0";
                        from = data.outletName
                        to = data.outletName
                        isFromCountShow = false
                        toNewCount =
                          parseInt(toNewCount) + parseInt(toLastCount)
                      } else if (
                        removeSpacewithLowerCaseString(data.movementName) ==
                        'transfer(adjustment)'
                      ) {
                        //need to be tested fully
                        from = data.destinationOutletName
                        to = data.outletName
                        fromLastCount = fromNewCount
                        fromNewCount = '0'
                        toNewCount =
                          parseInt(toNewCount) + parseInt(toLastCount)
                        // isToCountShow = false;
                      } else if (
                        removeSpacewithLowerCaseString(data.movementName) ==
                        'transfer(cancelled)'
                      ) {
                        //need to be tested fully
                        from = data.destinationOutletName
                        to = data.outletName
                        isFromCountShow = false
                        fromNewCount =
                          parseInt(fromLastCount) - parseInt(quantity)
                        toNewCount = parseInt(toLastCount) + parseInt(quantity)
                      }
                    }
                  } else if (recordTypeID == EntitiesEnum.InventoryTakes) {
                    redirectURL = `/Dashboard/inventory/inventorycount/${data.recordID}`
                    from = data.outletName
                    to = data.outletName
                    if (
                      removeSpacewithLowerCaseString(data.movementName) ==
                      'inventorycount(loss)'
                    ) {
                      isToCountShow = false
                    }
                    if (
                      removeSpacewithLowerCaseString(data.movementName) ==
                      'inventorycount(gain)'
                    ) {
                      isFromCountShow = false
                      toNewCount =
                        parseInt(fromLastCount) + parseInt(fromNewCount)
                    }
                  } else if (recordTypeID == EntitiesEnum.SalesOrder) {
                    redirectURL = `/dashboard/sell/salehistory/listing/${data.recordID}`
                    let salesOrderStatusID = getDecryptID(data.statusID)
                    if (salesOrderStatusID == SalesOrderStatusesEnum.LAYBY) {
                      from = data.outletName
                      to = data.customerName
                      if (isComposite) {
                        fromNewCount = parseInt(fromNewCount)
                        toNewCount =
                          parseInt(fromLastCount) - parseInt(toNewCount)
                      } else {
                        fromNewCount =
                          parseInt(fromLastCount) - parseInt(fromNewCount)
                        toNewCount = toNewCount
                      }

                      toLastCount = '0'
                    } else if (
                      salesOrderStatusID == SalesOrderStatusesEnum.LAYBY_CLOSED
                    ) {
                      from = data.customerName
                      to = data.customerName
                      fromNewCount = ''
                      fromLastCount = ''
                      toNewCount = ''
                      toLastCount = ''
                    } else if (
                      salesOrderStatusID == SalesOrderStatusesEnum.ONACCOUNT
                    ) {
                      from = data.outletName
                      to = data.customerName
                      toNewCount = ''
                      toLastCount = ''
                      if (isComposite) {
                        fromNewCount = parseInt(fromNewCount)
                        toNewCount =
                          parseInt(fromLastCount) - parseInt(toNewCount)
                      } else {
                        fromNewCount =
                          parseInt(fromLastCount) - parseInt(fromNewCount)
                      }
                    } else if (
                      salesOrderStatusID ==
                      SalesOrderStatusesEnum.ONACCOUNT_CLOSED
                    ) {
                      //ye case nhi chalega kbhe
                      from = data.customerName
                      to = data.customerName
                      fromNewCount = ''
                      fromLastCount = ''
                      toNewCount = ''
                      toLastCount = ''
                    } else if (
                      salesOrderStatusID ==
                      SalesOrderStatusesEnum.AWAITING_PICKUP
                    ) {
                      from = data.outletName
                      to = data.outletName
                      toNewCount = ''
                      toLastCount = ''
                      if (isComposite) {
                        fromNewCount = parseInt(fromNewCount)
                      } else {
                        fromNewCount =
                          parseInt(fromLastCount) - parseInt(fromNewCount)
                      }
                    } else if (
                      salesOrderStatusID ==
                      SalesOrderStatusesEnum.PICKED_UP_CLOSED
                    ) {
                      from = data.outletName
                      to = data.customerName
                      toNewCount = ''
                      toLastCount = ''
                      fromNewCount = ''
                      fromLastCount = ''
                    } else if (
                      salesOrderStatusID ==
                      SalesOrderStatusesEnum.AWAITING_DISPATCH
                    ) {
                      from = data.outletName
                      to = data.outletName
                      toNewCount = ''
                      toLastCount = ''
                      if (isComposite) {
                        fromNewCount = parseInt(fromNewCount)
                      } else {
                        fromNewCount =
                          parseInt(fromLastCount) - parseInt(fromNewCount)
                      }
                    } else if (
                      salesOrderStatusID ==
                      SalesOrderStatusesEnum.DISPATCHED_CLOSED
                    ) {
                      from = data.outletName
                      to = data.customerName
                      toNewCount = ''
                      toLastCount = ''
                      fromNewCount = ''
                      fromLastCount = ''
                    } else if (
                      salesOrderStatusID == SalesOrderStatusesEnum.CLOSED
                    ) {
                      from = data.outletName
                      to = !StringIsNullOrEmpty(data.customerName)
                        ? data.customerName
                        : 'Customer'
                      if (isComposite) {
                        fromNewCount = parseInt(fromNewCount)
                      } else {
                        fromNewCount =
                          parseInt(fromLastCount) - parseInt(fromNewCount)
                      }

                      toNewCount = ''
                      toLastCount = ''
                    } else if (
                      salesOrderStatusID ==
                      SalesOrderStatusesEnum.RETURN_COMPLETED
                    ) {
                      if (
                        removeSpacewithLowerCaseString(toMessage) === 'unknown'
                      ) {
                        toNewCount = ''
                        toLastCount = ''
                        from = data.outletName
                        to = 'Unknown'
                        toMessage = ''
                        if (fromNewCount == 0) {
                          fromNewCount = ''
                          fromLastCount = ''
                        }
                      } else {
                        from = !StringIsNullOrEmpty(data.customerName)
                          ? data.customerName
                          : 'Customer'
                        to = data.outletName
                        if (isComposite) {
                          toNewCount = parseInt(toNewCount) //check
                          quantity = quantity < 0 ? quantity * -1 : quantity
                        } else {
                          toNewCount =
                            parseInt(fromLastCount) + parseInt(fromNewCount) //check
                        }

                        fromNewCount = ''
                        fromLastCount = ''
                      }
                    } else if (
                      salesOrderStatusID == SalesOrderStatusesEnum.VOIDED
                    ) {
                      if (
                        removeSpacewithLowerCaseString(toMessage) === 'unknown'
                      ) {
                        toNewCount = ''
                        toLastCount = ''
                        from = data.outletName
                        to = 'Unknown'
                        toMessage = ''
                        if (fromNewCount == 0) {
                          fromNewCount = ''
                          fromLastCount = ''
                        }
                      } else {
                        from = !StringIsNullOrEmpty(data.customerName)
                          ? data.customerName
                          : 'Customer'
                        to = data.outletName
                        if (isComposite) {
                          quantity = quantity < 0 ? quantity * -1 : quantity
                          fromNewCount = parseInt(fromNewCount)
                        } else {
                          toNewCount =
                            parseInt(toLastCount) + parseInt(toNewCount)
                        }

                        fromNewCount = ''
                        fromLastCount = ''
                      }
                    } else if (
                      salesOrderStatusID ==
                      SalesOrderStatusesEnum.EXCHANGE_COMPLETED
                    ) {
                      if (
                        removeSpacewithLowerCaseString(data.movementName) ===
                        'salereturn'
                      ) {
                        from = !StringIsNullOrEmpty(data.customerName)
                          ? data.customerName
                          : 'Customer'
                        to = data.outletName
                        if (isComposite) {
                          toNewCount = parseInt(toNewCount) //check
                          quantity = quantity < 0 ? quantity * -1 : quantity
                        } else {
                          toNewCount =
                            parseInt(fromLastCount) + parseInt(fromNewCount) //check
                        }
                        fromNewCount = ''
                        fromLastCount = ''
                      } else {
                        from = data.outletName
                        to = !StringIsNullOrEmpty(data.customerName)
                          ? data.customerName
                          : 'Customer'
                        if (isComposite) {
                          fromNewCount = parseInt(fromNewCount)
                        } else {
                          fromNewCount =
                            parseInt(fromLastCount) - parseInt(fromNewCount)
                        }

                        toNewCount = ''
                        toLastCount = ''
                      }
                    }
                  }
                  return {
                    key: i,
                    Date: !StringIsNullOrEmpty(data.date)
                      ? moment(data.date).format('DD MM YYYY HH:mm')
                      : '',
                    Movement: !StringIsNullOrEmpty(data.movementName)
                      ? data.movementName
                      : '',
                    From: from,
                    To: to,
                    FromMessage: fromMessage,
                    ToMessage: toMessage,
                    FromNewCount: fromNewCount,
                    FromLastCount: fromLastCount,
                    ToNewCount: toNewCount,
                    ToLastCount: toLastCount,
                    Quantity: quantity,
                    RedirectURL: redirectURL,
                    VariantName: variantName,
                    IsFromCountShow: isFromCountShow,
                    IsToCountShow: isToCountShow
                  }
                }
              )

              let paginationObj = {
                CurrentPageNo:
                  res.data.data.productMovementListings[0].currentPageNo,
                PageSize: res.data.data.productMovementListings[0].pageSize,
                total:
                  res.data.data.productMovementListings.length > 0
                    ? res.data.data.productMovementListings[0].totalRecords
                    : 0,
                current: res.data.data.productMovementListings[0].currentPageNo
              }

              setProductMovementsData(mapped)
              setPagination(paginationObj)
              setProductName(res.data.data.productName)
            } else {
              setProductMovementsData([])
              setPagination([])
              // message.error("Inventory movement Data not exist");
            }
          } else {
            setPagination([])
            message.error(res.data.data.errorMessage)
          }
        } else {
          setPagination([])
          message.error(res.data.data.errorMessage)
        }
      })
      .catch(error => {
        setListingLoader(false)
      })
  }

  const handleTableChange = (pagination, filters, sorter) => {
    let fromDate = getFromDate // moment().subtract(8, "day").format("YYYY-MM-DD");
    let toDate = getToDate // moment().format("YYYY-MM-DD");
    let body = {
      CurrentPageNo: pagination.current,
      PageSize: pagination.pageSize,
      ProductID: productID,
      FromDate: fromDate,
      ToDate: toDate,
      InventoryMovementStatusID:
        searchFilterData.InventoryMovementStatusID != undefined
          ? searchFilterData.InventoryMovementStatusID
          : '',
      OutletID:
        searchFilterData.OutletID != undefined ? searchFilterData.OutletID : ''
    }
    setSearchFilterData(body)
    getProductMovementsListing(body)
  }

  async function getOutletsService () {
    const getOutlets = ds.getStoreOutlets()
    await getOutlets
      .then(response => {
        if (response.status == 200) {
          if (response.data.msgCode == 'GENERAL_SUCCESS') {
            if (response.data.data && response.data.data.length > 0) {
              let data = response.data.data
              let all = {
                OutletID: '0&&_ASD56_UIO78_PQW88',
                outletName: 'All'
              }
              data.unshift(all)
              let outletsData = data.map(e => {
                return {
                  OutletID: getDecryptID(e.sOutletId),
                  OutletName: e.outletName
                }
              })
              setOutletData(outletsData)
            }
          }
        }
      })
      .catch(e => {})
  }
  const onFinish = values => {
    if (values != null) {
      let body = {
        ProductID: productID,
        InventoryMovementStatusID:
          values.MovementStatusID != undefined ? values.MovementStatusID : '',
        OutletID: values.OutletID != undefined ? values.OutletID : '',
        FromDate: getFromDate,
        ToDate: getToDate,
        CurrentPageNo: 1, //getPagination.CurrentPageNo,
        PageSize: getPagination.PageSize ? getPagination.PageSize : 10
      }

      setSearchFilterData(body)
      getProductMovementsListing(body)
    }
  }
  const onFinishFailed = errorInfo => {
    message.error('Kindly provide correct data')
  }

  function onDateChange (date, dateString) {
    if (date != null) {
      setFromDate(date[0].format('YYYY-MM-DD'))
      setToDate(date[1].format('YYYY-MM-DD'))
    }
  }
  const columns = [
    {
      title: <IntlMessages id='reporting.productInventorymovements.date' />,
      dataIndex: 'Date',
      key: 'Date',
      render: (text, record) => {
        return <p>{text}</p>
      }
    },
    {
      title: (
        <IntlMessages id='reporting.productInventorymovements.variantName' />
      ),
      dataIndex: 'VariantName',
      key: 'VariantName',
      render: (text, record) => {
        return <p>{text}</p>
      },
      hidden: getProductInventoryTypeID != 5 ? true : false
    },
    {
      title: <IntlMessages id='reporting.productInventorymovements.movement' />,
      dataIndex: 'Movement',
      key: 'Movement',
      render: (text, record) => {
        const { RedirectURL } = record

        return (
          <div>
            {RedirectURL ? (
              <a onClick={() => history.push(RedirectURL)} className='gx-link'>
                {text}
              </a>
            ) : (
              <p>{text}</p>
            )}
          </div>
        )
      }
    },
    {
      title: <IntlMessages id='reporting.productInventorymovements.from' />,
      dataIndex: 'From',
      key: 'From',
      render: (text, record) => {
        return (
          <>
            <Row>
              <p className='dk-mg-bt-1'>{text} &nbsp;</p>
              {record.IsFromCountShow ? (
                !StringIsNullOrEmpty(record.FromLastCount) &&
                !StringIsNullOrEmpty(record.FromNewCount) ? (
                  <span class='dk-flag'>
                    <span>
                      {record.FromLastCount}{' '}
                      <span class='dk-flag-chevron'></span>{' '}
                      {record.FromNewCount}
                    </span>
                  </span>
                ) : (
                  ''
                )
              ) : (
                ''
              )}
            </Row>
            {!StringIsNullOrEmpty(record.FromMessage) ? (
              <Row>
                <Col>
                  <span className='dk-font-10'>{' ' + record.FromMessage}</span>
                </Col>
              </Row>
            ) : (
              ''
            )}
          </>
        )
      }
    },
    {
      title: <IntlMessages id='reporting.productInventorymovements.to' />,
      dataIndex: 'To',
      key: 'To',
      render: (text, record) => {
        return (
          <>
            <Row>
              <p className='dk-mg-bt-1'>{text} &nbsp; </p>
              {record.IsToCountShow ? (
                !StringIsNullOrEmpty(record.ToLastCount) &&
                !StringIsNullOrEmpty(record.ToNewCount) ? (
                  <span class='dk-flag'>
                    <span>
                      {record.ToLastCount} <span class='dk-flag-chevron'></span>{' '}
                      {record.ToNewCount}
                    </span>
                  </span>
                ) : (
                  ''
                )
              ) : (
                ''
              )}
            </Row>
            {!StringIsNullOrEmpty(record.ToMessage) ? (
              <Row>
                <Col>
                  <span className='dk-font-10'>{' ' + record.ToMessage}</span>
                </Col>
              </Row>
            ) : (
              ''
            )}
          </>
        )
      }
    },
    {
      title: <IntlMessages id='reporting.productInventorymovements.quantity' />,
      dataIndex: 'Quantity',
      key: 'Quantity',
      render: (text, record) => {
        return <p>{text}</p>
      }
    }
  ].filter(item => !item.hidden)

  const redirectToListing = () => {
    history.push('/Dashboard/inventory/inventorycount/listing')
  }
  const FormFields = () => {
    const children = []
    children.push(
      <Col lg={8} md={8} sm={12} xs={24} style={{ display: 'block' }}>
        <div className='gx-form-row0'>
          <Form.Item
            className='ant-form-item-label-custom dk-flex-col'
            name={`MovementStatusID`}
            label={
              <IntlMessages id='reporting.productInventorymovements.movement' />
            }
          >
            <Select
              size='middle'
              showSearch={checkIsWeb().exist}
              optionFilterProp='children'
            >
              {getMovementStatuses &&
                getMovementStatuses.map((e, key) => {
                  return (
                    <Select.Option
                      key={key}
                      value={getDecryptID(e.inventoryMovementStatusID)}
                    >
                      {e.displayName}
                    </Select.Option>
                  )
                })}
            </Select>
          </Form.Item>
        </div>
      </Col>,
      <Col lg={8} md={8} sm={12} xs={24} style={{ display: 'block' }}>
        <div className='gx-form-row0'>
          <Form.Item
            className='ant-form-item-label-custom dk-flex-col'
            name={`OutletID`}
            label={
              <IntlMessages id='reporting.productInventorymovements.outlet' />
            }
          >
            <Select
              size='middle'
              showSearch={checkIsWeb().exist}
              optionFilterProp='children'
            >
              {outletData &&
                outletData.map((e, key) => {
                  return (
                    <Select.Option key={key} value={e.OutletID}>
                      {e.OutletName}
                    </Select.Option>
                  )
                })}
            </Select>
          </Form.Item>
        </div>
      </Col>,
      <Col lg={8} md={8} sm={12} xs={24} style={{ display: 'block' }}>
        <div className='gx-form-row0'>
          <Form.Item
            className='ant-form-item-label-custom dk-flex-col'
            name={`DateRange`}
            label={
              <IntlMessages id='reporting.productInventorymovements.daterange' />
            }
          >
            <RangePicker
              onChange={onDateChange}
              defaultValue={[
                moment(
                  getFromDate != undefined && getFromDate != ''
                    ? getFromDate
                    : moment().format('DD-MM-YYYY'),
                  'DD-MM-YYYY'
                ),
                moment(
                  getToDate != undefined && getToDate != ''
                    ? getToDate
                    : moment().subtract(8, 'day').format('DD-MM-YYYY'),
                  'DD-MM-YYYY'
                )
              ]}
              format='DD-MM-YYYY'
              range
              size='middle'
              className='gx-mb-3 gx-w-100'
              inputReadOnly={true}
            />
          </Form.Item>
        </div>
      </Col>
    )
    return children
  }

  return (
    <div className='product-movements-form'>
      {isComponent ? (
        ''
      ) : (
        <>
          <div className='back-arrow-h1'>
            <h1 className='d-flex align-items-center'>
              <ArrowLeftOutlined
                className='dk-vertical-align'
                onClick={() => history.goBack()}
              />
              <span className='mx-2'> {getProductName}</span>
            </h1>
          </div>

          <Card className='gx-card'>
            <Panel
              className='custom-promolist-help'
              showArrow={false}
              header={
                <IntlMessages id='reporting.productInventorymovements.seeallinventory' />
              }
              Collapse={false}
            ></Panel>
          </Card>
        </>
      )}

      <Card className='gx-card mt-3 Filters-wrapper No-BoxShadow'>
        <Form
          form={form}
          name='advanced_search'
          className='ant-advanced-search-form product-search-form Filters-Form'
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          initialValues={{
            OutletID: '0',
            MovementStatusID: '1'
          }}
        >
          <Row>{FormFields()}</Row>

          <Col span={24} lg={24} md={24} xs={24} sm={24} className='text-right'>
            <Space size='middle'>
              <Form.Item>
                <Button className='' type='primary' htmlType='submit'>
                  <IntlMessages id='reporting.productInventorymovements.search' />
                </Button>
              </Form.Item>
            </Space>
          </Col>
        </Form>
      </Card>

      {getListingLoader ? (
        <Skeleton count={5} height={30} />
      ) : (
        <>
          {isComponent ? (
            <Table
              className='gx-table-responsive'
              columns={columns}
              dataSource={getProductMovementsData}
              pagination={false}
            />
          ) : (
            <Table
              className='gx-table-responsive'
              columns={columns}
              dataSource={getProductMovementsData}
              pagination={getPagination}
              onChange={handleTableChange}
            />
          )}
        </>
      )}
    </div>
  )
}

export default InventoryMovementListing
